import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LocalRepository } from '@shared/helper/local-repository';
import { ServiceResult } from '@shared/helper/service-result';
import { TServiceResult } from '@shared/helper/t-service-result';
import { Observable } from 'rxjs';
import { HttpBaseService } from '../base_services/http_base.service';
import { share } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class ActivitiesUpdateService extends HttpBaseService {

    constructor() {
        const repo = inject(LocalRepository);
        const http = inject(HttpClient);

        super(repo, http, 'acup');
    }

    setSeenByItemId(itemId: string): Observable<ServiceResult> {
        return this.http.get<ServiceResult>(`${this.apiUrl}/Seen/${itemId}`).pipe(share());
    }

    setSeenAllNotifications(): Observable<ServiceResult> {
        return this.http.get<ServiceResult>(`${this.apiUrl}/SeenAll`);
    }

    getUnSeenNotificationsCount(): Observable<TServiceResult<number>> {
        return this.http.get<TServiceResult<number>>(`${this.apiUrl}/GetUnSeenUpdatesCount`);
    }


}